import React from 'react'

const LocationAlt2Icon = props => (
  <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.4"
      d="M20 17.9167C20 19.62 15.5233 21 10 21C4.47667 21 0 19.62 0 17.9167C0 16.719 2.215 15.6793 5.45033 15.1713C5.91267 15.0987 6.381 15.2763 6.683 15.634C7.44733 16.5383 8.17167 17.254 8.693 17.7367C9.25933 18.256 10.09 18.412 10.8467 18.0623C11.0197 17.9823 11.1753 17.8693 11.3157 17.7403C11.827 17.2707 12.559 16.5503 13.3313 15.634C13.6327 15.2763 14.102 15.0993 14.5643 15.1723C17.792 15.683 20 16.7193 20 17.9167Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0063 0C10.1867 0 10.3663 0.00666667 10.5497 0.0233333C14.0463 0.32 16.52 3.57 16.1933 7.06333C15.91 10.0633 14.1733 12.75 12.61 14.6067C11.8467 15.5133 11.1297 16.22 10.6397 16.67C10.4597 16.8333 10.233 16.9167 10.0063 16.9167C9.77966 16.9167 9.55333 16.8333 9.373 16.67C8.883 16.22 8.16633 15.5133 7.40633 14.6067C5.69966 12.5767 3.77966 9.55 3.77966 6.22667C3.77966 2.78667 6.56633 0 10.0063 0ZM7.633 6.22667C7.633 7.53333 8.693 8.59333 9.99966 8.59333C11.3063 8.59333 12.3663 7.53333 12.3663 6.22667C12.3663 4.92 11.3063 3.86 9.99966 3.86C8.693 3.86 7.633 4.92 7.633 6.22667Z"
      fill="white"
    />
  </svg>
)

export default LocationAlt2Icon
